
import React from 'react';

interface VolumeWaveIndicatorProps {
  isActive?: boolean;
  barCount?: number;
  className?: string;
}

export const VolumeWaveIndicator = ({ 
  isActive = true, 
  barCount = 8,
  className = ""
}: VolumeWaveIndicatorProps) => {
  const generateBars = () => {
    const bars = [];
    
    for (let i = 0; i < barCount; i++) {
      // Create different animation delays and heights for each bar
      const animationDelay = i * 0.05; // Reducido de 0.1 a 0.05 para más velocidad
      const baseHeight = Math.random() * 0.4 + 0.3; // Random height between 30% and 70%
      
      bars.push(
        <div
          key={i}
          className={`
            w-1 bg-gradient-to-t from-green-600 via-green-500 to-green-400 rounded-full
            ${isActive ? 'animate-pulse' : ''}
          `}
          style={{
            height: `${baseHeight * 100}%`,
            animationDelay: `${animationDelay}s`,
            animationDuration: '0.6s', // Reducido de 1.2s a 0.6s para doble velocidad
            transform: isActive ? 'scaleY(1)' : 'scaleY(0.3)',
            transition: 'transform 0.15s ease-in-out', // Más rápido también
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
            animationDirection: 'alternate',
          }}
        />
      );
    }
    
    return bars;
  };

  return (
    <div className={`flex items-end justify-center space-x-1 h-4 ${className}`}>
      {generateBars()}
    </div>
  );
};
